export default __webpack_public_path__ + "static/media/icon-leaf.1bc368ae.svg";